/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import COLOR_OPTIONS from '../../constants/binarySensorsColors';
import i18next from '../../services/i18n';

const isValidColor = ({ color }) => Object.keys(COLOR_OPTIONS).includes(color);

const triggerError = (key, value, errors) => {
  if (!errors) errors = {};
  errors.threshold = {
    ...(errors?.threshold || {}),
    [key]: {
      ...(errors?.threshold?.[key] || {}),
      ...value,
    },
  };
};

export default ({ values, errors }) => {
  if (!values?.threshold) return;

  /* sensor color 0 (low) */
  if (!values.threshold['0']?.color)
    triggerError(0, { color: i18next.t('validation.required') }, errors);
  else if (!isValidColor({ color: values.threshold['0']?.color }))
    triggerError(0, { color: i18next.t('validation.invalid_color') }, errors);

  /* sensor color 1 (high) / color duplication */
  if (!values.threshold['1']?.color) triggerError(1, { color: 'Required!' });
  else if (!isValidColor({ color: values.threshold['1']?.color }))
    triggerError(1, { color: i18next.t('validation.invalid_color') }, errors);
  else if (
    values.threshold['1']?.color === values.threshold['0']?.color &&
    values.threshold['1']?.color !== 'on'
  )
    triggerError(1, { color: i18next.t('validation.duplicate_color') }, errors);

  /* icon/text mutual exclusion */
  if (!values.threshold['0']?.icon && !values.threshold['0']?.text)
    triggerError(0, { indicator: true }, errors);
  if (!values.threshold['1']?.icon && !values.threshold['1']?.text)
    triggerError(1, { indicator: true }, errors);

  if (values.threshold['1']?.text?.length > 10)
    triggerError(
      1,
      { text: i18next.t('validation.max_length', { maxLength: 10 }) },
      errors,
    );
  if (values.threshold['0']?.text?.length > 10)
    triggerError(
      0,
      { text: i18next.t('validation.max_length', { maxLength: 10 }) },
      errors,
    );

  if (!values.threshold['1']?.message)
    triggerError(1, { message: i18next.t('validation.required') }, errors);
  else if (values.threshold['1']?.message?.length > 30)
    triggerError(
      1,
      { message: i18next.t('validation.max_length', { maxLength: 30 }) },
      errors,
    );
  if (!values.threshold['0']?.message)
    triggerError(0, { message: i18next.t('validation.required') }, errors);
  else if (values.threshold['0']?.message?.length > 30)
    triggerError(
      0,
      { message: i18next.t('validation.max_length', { maxLength: 30 }) },
      errors,
    );
};
